import { motion } from "framer-motion";
import { Users, User } from "lucide-react";

const fadeUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.5, ease: [0.33, 1, 0.68, 1] },
};

const scrollTo = (id) => {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
};

const options = [
  {
    icon: Users,
    title: "Group Classes",
    desc: "High-intensity sessions in a controlled environment. Learn alongside others, push harder, build instinct under pressure.",
    cta: "Join a Class",
  },
  {
    icon: User,
    title: "Personal Training",
    desc: "One-on-one, purpose-built for you. Tailored drills, threat scenarios, and conditioning — at your pace, on your schedule.",
    cta: "Book a Session",
  },
];

export const TrainingOptionsSection = () => {
  return (
    <section
      id="training-options"
      data-testid="training-options-section"
      className="relative px-6 md:px-16 lg:px-24 py-12 md:py-16"
    >
      <div className="section-divider mb-10 md:mb-14" />

      <motion.div {...fadeUp} className="mb-8 md:mb-10">
        <div className="brass-line mb-4" />
        <span className="text-[10px] tracking-[0.3em] uppercase text-sig font-['IBM_Plex_Sans'] block mb-3">
          Train Your Way
        </span>
        <h2
          data-testid="training-options-headline"
          className="font-['Oswald'] text-3xl md:text-4xl lg:text-5xl font-bold uppercase tracking-tight leading-[0.95] text-ink"
        >
          Choose Your <span className="text-sig">Path.</span>
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {options.map((opt, i) => (
          <motion.div
            key={opt.title}
            {...fadeUp}
            transition={{ ...fadeUp.transition, delay: i * 0.12 }}
            data-testid={`option-${i + 1}`}
            className="border border-line p-6 md:p-8 group cursor-pointer hover:border-sig/40 transition-colors duration-300"
            onClick={() => scrollTo("contact")}
          >
            <opt.icon className="w-5 h-5 text-sig mb-5" strokeWidth={1.5} />
            <h3 className="font-['Oswald'] text-xl md:text-2xl font-bold uppercase tracking-wide text-ink group-hover:text-sig transition-colors duration-300 mb-3">
              {opt.title}
            </h3>
            <p className="text-sm leading-[1.6] text-mute font-['IBM_Plex_Sans'] font-light mb-5">
              {opt.desc}
            </p>
            <span className="text-[10px] tracking-[0.25em] uppercase text-sig font-['IBM_Plex_Sans'] font-bold group-hover:tracking-[0.35em] transition-all duration-300">
              {opt.cta} &rarr;
            </span>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
